import EventEmitter from 'eventemitter3';

export default class BackgroundManager extends EventEmitter {

    _styleConsole = 'background: #222; color: #ff8c8c';
    _classes = {
        backgroundContainer: 'js-background-container',
        backgroundItem: 'js-background-item',
        initLoad: 'anim-init-load'
    };
    _background = {
        old : 0,
        current : 0,
        next : 0
    }

    constructor() {
        super();

        this._retrieveDOM();
        this.bind();
    }

    _retrieveDOM() {

        this._views = {};

        // Backgrounds
        this._views.background = {
            container : document.body.querySelector( '.' + this._classes.backgroundContainer ),
            items : null
        }
        this._views.background.items = this._views.background.container.querySelectorAll( '.' + this._classes.backgroundItem );

        this._initDataDOM();
    }

    _initDataDOM() {}

    bind() {}

    setIndex( index ) {
        this._background = index;
    }

    _initClass() {
        this._setBackground();
    }

    initLoad() {
        this._views.background.container.classList.remove( this._classes.initLoad );
    }

    _setBackground() {
        // for( let i = 0, j = this._background.current; i <= j; i++ ) {
        //     let background = this._views.background.items[ i ];
        //     // background.classList.add('show');
        //     // TweenMax.to(background, 0, {autoAlpha: 1});
        //     background.style.visibility = "visible";
        //     background.style.opacity = 1;
        // }

        let background = this._views.background.items[ this._background.current ];
        background.style.display = "block";
        background.style.opacity = 1;
    }

    // resize() {}
    // update( top ) {}

    updateBackground( direction ) {

        let oldBackground = this._views.background.items[ this._background.old ];
        TweenMax.to(oldBackground, 0.6, {opacity: 0, ease: Power0.easeNone, onComplete: () => {
                oldBackground.style.display = 'none';
            } });

        let newBackground = this._views.background.items[ this._background.current ];
        TweenMax.to(newBackground, 0.6, {opacity: 1, ease: Power0.easeNone, onStart:() => {
                newBackground.style.display = 'block';
        }});
    }

    // updateBackground( direction ) {
    //
    //     if( direction == 'next' ) {
    //
    //         // for "click date"
    //         if( this._background.current - this._background.old > 1 ) {
    //             for( let i = this._background.old + 1, j = this._background.current; i < j; i++ ) {
    //                 let itemBackground = this._views.background.items[ i ];
    //                 itemBackground.style.visibility = "visible";
    //                 itemBackground.style.opacity = 1;
    //             }
    //         }
    //         //////////////////////////////
    //
    //         let newBackground = this._views.background.items[ this._background.current ];
    //         // newBackground.classList.add('show');
    //         TweenMax.to(newBackground, 0.6, {autoAlpha: 1, ease: Power0.easeNone});
    //     }
    //
    //     if( direction == 'prev' ) {
    //
    //         // for "click date"
    //         if( this._background.old - this._background.current > 1 ) {
    //             for( let i = this._background.current + 1, j = this._background.old; i < j; i++ ) {
    //                 let itemBackground = this._views.background.items[ i ];
    //                 itemBackground.style.visibility = "hidden";
    //                 itemBackground.style.opacity = 0;
    //             }
    //         }
    //         //////////////////////////////
    //
    //         let oldBackground = this._views.background.items[ this._background.old ];
    //         // oldBackground.classList.remove('show');
    //         TweenMax.to(oldBackground, 0.6, {autoAlpha: 0, ease: Power0.easeNone});
    //     }
    // }
}


// WEBPACK FOOTER //
// ./src/js/pages/history/modules/background-manager.js